import { render, staticRenderFns } from "./AnswerInput.vue?vue&type=template&id=7e51e4ca&scoped=true&"
import script from "./AnswerInput.vue?vue&type=script&lang=js&"
export * from "./AnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./AnswerInput.vue?vue&type=style&index=0&id=7e51e4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e51e4ca",
  null
  
)

export default component.exports